import React, { useState, useEffect } from 'react'
import "./CustomDatatableJournal.css";
import { useNavigate } from 'react-router-dom';
import { BiEdit } from "react-icons/bi"
import Pagination from '../Pagination/Pagination';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { customFormatDate, customFormatHour } from '../../utils/utils';

const CustomDatatableJournal = (props) => {

    const { columns, 
            data, 
            changePage,
            pageCount,
            pageNumber,
            perPage, } = props;
    const dispatch = useDispatch();


    const navigate = useNavigate();

    const states = useSelector((state) => state, shallowEqual);

    return (
        <div className="table-responsive ">
            <table className="table table-striped dataTable w-100">
                <thead className="">
                    <tr role={"row"}>
                        {columns && columns.map((item, index) =>
                            <th key={index+"wcdjc"} style={{ "color": "dodgerblue" }} className="suivi-taux-theader text-left pl-5" >
                                {item.label}</th>
                        )}
                        {/* <th className="text-center w-30">Action</th> */}
                    </tr>
                </thead>
                <tbody>
                    {data.length != 0 ? data?.map((item, index) =>
                        <tr key={index+"wcdjd"}>

                            <td className="text-left pl-5">{pageNumber > 1 ? (perPage*(pageNumber-1) + (index + 1)) : (index+1)}</td>
                            <td className="text-left pl-5">
                                {customFormatDate(item.created_at)}
                            </td>
                            <td className="text-left pl-5">
                                {customFormatHour(item.created_at)}
                            </td>
                            <td className="text-left pl-5">
                                {item.description}
                            </td>
                            <td className="text-left pl-5">
                                {item.prenom}{" "}{item.nom}
                            </td>
                            <td className="text-left pl-5">
                                {item.institution ? item.institution : "Néant"}
                            </td>




                        </tr>
                    ) : <h1 className="ok"></h1>}
                </tbody>
            </table>
            <Pagination pageCount={pageCount} changePage={changePage} />
        </div>
    )
}

export default CustomDatatableJournal